/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_DISCOUNT_CODES = gql`
 query GetDiscountReferals($filter: CommitteeFilter, $options: GetManyOptions) {
  getDiscountReferals(filter: $filter, options: $options) {
    content {
       _id
      createdBy {
        email
      }
      discountCodes {
        discountCode
        status
        committeeId {
          email
        }
        adminId {
          email
        }
        masqId {
          email
        }
      }
      discountType
    }
    count
    limit
    skip
  }
}
`;
